import { useEffect, useState, useRef } from 'react'
import { useGetAuthorizationToken } from './useGetAuthorizationToken'
import { io } from 'socket.io-client'

interface Message {
  answer: string
  generation_id: number
}

export const useGetSocketMessage = () => {
  const [isConnecting, setIsConnecting] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [message, setMessage] = useState<ChatInterface>()
  const { accessToken, isFetchingAccessToken } = useGetAuthorizationToken()
  const socket = useRef<any>(null)

  const onConnect = () => {
    console.log('Connected')
    setIsConnecting(false)
    selectAssistant('asst_NmdMxigegiPHnS0WLshyNTX9')
  }

  const onChatMessage = (data: Message) => {
    const date = new Date()

    setMessage({
      id: data.generation_id,
      type: 'bot',
      date: date,
      articles: [],
      text: data.answer,
    })

    setIsLoading(false)
    console.log('Received a message:', data)
  }

  const onDisconnect = () => {
    console.log('Disconnected')
  }

  const onError = (error: any) => {
    setIsConnecting(false)
    setIsLoading(false)
    console.error(error)
    setError(error)
  }

  const selectAssistant = (assistantId: string) => {
    socket.current.emit('select_assistant', assistantId)
  }

  const sendMessage = (message: string) => {
    setIsLoading(true)
    socket.current.emit('chat_message', message)
  }

  useEffect(() => {
    if (accessToken) {
      console.log('Connecting to socket', accessToken)

      socket.current = io('https://atm.tamedia.ch', {
        path: '/api/ai-tools/v1/socket.io',
        reconnection: false,
        // transports: ["websocket"],
        extraHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      })

      socket.current.on('connect', onConnect)
      socket.current.on('chat_message', onChatMessage)
      socket.current.on('disconnect', onDisconnect)
      socket.current.on('error', onError)
      socket.current.on("connect_error", onError)
    }

    return () => {
      if (socket.current) {
        socket.current.off('connect', onConnect)
        socket.current.off('disconnect', onDisconnect)
        socket.current.off('error', onError)
        socket.current.off("connect_error", onError)
        socket.current.disconnect()
      }
    }
  }, [accessToken])

  return {
    selectAssistant,
    sendMessage,
    message,
    isLoading,
    isConnecting,
    error
  }
}
